module.exports = __webpack_public_path__ + "static/media/BattleBudResp3-3.2d42f5aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/BattleBudResp3-3.svg
// module id = 650
// module chunks = 0